var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-template",
    [
      _c("template", { slot: "page-content" }, [
        _c("div", { staticClass: "taste--template bg-beige page-template" }, [
          _c("div", {
            staticClass: "db fixed top-0 bottom-0 bg-beige w-100 vh-100 z-bg",
          }),
          _vm._v(" "),
          _c("div", { staticClass: "relative z-content" }),
          _vm._v(" "),
          _c("div", { staticClass: "relative z-content pb5" }, [
            _c("div", { staticClass: "relative" }, [
              _c("div", { staticClass: "relative mw8-5 center pt4 pt5-ns" }, [
                _c("div", { staticClass: "row relative center mb4" }, [
                  _c(
                    "div",
                    { staticClass: "db relative w-100 taste-heading" },
                    [
                      _c(
                        "h1",
                        {
                          staticClass:
                            "f1 is-navy tl lh-heading f45px is-blenny mw7-ns",
                        },
                        [
                          _vm._v(_vm._s(_vm.page.title) + "\n                "),
                          _c("img", {
                            staticClass: "dib mb3 lil-hat",
                            attrs: {
                              src: "/uploads/OL20-OL21_Icons/CocktailMagicIcon/CocktailMagicIconSVG/CocktailMagic_Icon_Infrared.svg",
                            },
                          }),
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "h2",
                        {
                          staticClass:
                            "db des-rest2 relative mb4 mb4-ns w-100 f22px is-tablet-regular link-bold lh-copy cms-content",
                        },
                        [
                          _vm._v(
                            "Deep in McLaren Pass, discover craft cocktails, magic shows and live music at Cocktail Magic! Three new bars will make their debut including Frank & Vlad's, The Silver Girls and The Buttery Tipple."
                          ),
                        ]
                      ),
                    ]
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("section", { staticClass: "relative mt6 mt0-ns" }, [
                _c(
                  "div",
                  { staticClass: "relative container-fluid-sm mw8-5 center" },
                  [
                    _c(
                      "div",
                      { staticClass: "row center" },
                      _vm._l(_vm.page.content_blocks, function (block, index) {
                        return _c(
                          "div",
                          { staticClass: "relative col-xs-12 col-sm-4" },
                          [
                            index === 1
                              ? _c("div", {
                                  staticClass:
                                    "dn db-ns top-0 left-0 h-100 absolute center cm-border is-navy",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            index === 1
                              ? _c("div", {
                                  staticClass:
                                    "dn db-ns top-0 right-0 h-100 absolute center cm-border is-navy",
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "w-100 center ph0 ph3-ns" },
                              [
                                _c("img", {
                                  directives: [
                                    {
                                      name: "lazy",
                                      rawName: "v-lazy",
                                      value: block.image,
                                      expression: "block.image",
                                    },
                                  ],
                                  staticClass: "mb3 center ml0 w-100 mw100",
                                }),
                                _vm._v(" "),
                                _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "f2 tl is-tablet-bold is-black",
                                  },
                                  [_vm._v(_vm._s(block.title))]
                                ),
                                _vm._v(" "),
                                block.is_cocktails
                                  ? _c(
                                      "div",
                                      { staticClass: "mt3" },
                                      _vm._l(block.items, function (item) {
                                        return _c(
                                          "div",
                                          { staticClass: "mv2" },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "f3 tl is-tablet-bold is-black",
                                              },
                                              [_vm._v(_vm._s(item.title))]
                                            ),
                                            _vm._v(" "),
                                            _c("hr", {
                                              staticClass: "cocktail-divide",
                                            }),
                                            _vm._v(" "),
                                            item.description
                                              ? _c("p", {
                                                  staticClass:
                                                    "f5 mt2 is-tablet-regular is-black",
                                                })
                                              : _vm._e(),
                                            _c("p", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(item.description)
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(_vm._s(item.description2)),
                                            ]),
                                            _vm._v(" "),
                                            _c("p"),
                                            _vm._v(" "),
                                            item.description3
                                              ? _c("p", {
                                                  staticClass:
                                                    " f5 mt2 is-tablet-regular is-black",
                                                })
                                              : _vm._e(),
                                            _c("p", [
                                              _c("b", [
                                                _vm._v(
                                                  "Specialty Cocktail Preview: "
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _c("b", [
                                                _vm._v(
                                                  _vm._s(item.description3)
                                                ),
                                              ]),
                                            ]),
                                            _vm._v(" "),
                                            _c("p", [
                                              _vm._v(_vm._s(item.description4)),
                                            ]),
                                            _vm._v(" "),
                                            _c("p"),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                block.is_magic
                                  ? _c(
                                      "div",
                                      { staticClass: "mt3" },
                                      _vm._l(block.items, function (item) {
                                        return _c(
                                          "div",
                                          { staticClass: "mv2" },
                                          [
                                            _c(
                                              "h3",
                                              {
                                                staticClass:
                                                  "f3 tl is-tablet-bold is-black",
                                              },
                                              [_vm._v(_vm._s(item.title))]
                                            ),
                                            _vm._v(" "),
                                            item.description
                                              ? _c("p", {
                                                  staticClass:
                                                    "f5 mt2 is-tablet-regular is-black",
                                                })
                                              : _vm._e(),
                                            _c("h3", [
                                              _vm._v(_vm._s(item.description)),
                                            ]),
                                            _vm._v(" "),
                                            _c("p"),
                                            _vm._v(" "),
                                            _c(
                                              "a",
                                              {
                                                staticClass:
                                                  "db mt2 relative is-tablet-bold f15px",
                                                attrs: {
                                                  href: item.link,
                                                  target: "_blank",
                                                },
                                              },
                                              [_vm._v("More →")]
                                            ),
                                          ]
                                        )
                                      }),
                                      0
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ]
                        )
                      }),
                      0
                    ),
                  ]
                ),
              ]),
            ]),
          ]),
        ]),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }